import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    destinationAcctNumber: '',
    beneficiaryList: [],   
    availableLimit: '',
    duplicateTransactionPeriod: 0
};
const mutations = {
    // set destination account number
    SET_DESTINATION_ACCT_NUMBER(state, destinationAcctNumber) {
        state.destinationAcctNumber = destinationAcctNumber;
    },
    // set beneficiary list
    SET_BENEFICIARY_LIST(state, beneficiaryList) {
        state.beneficiaryList = beneficiaryList;
    },
    // set available limit
    SET_AVAILABLE_LIMIT(state, availableLimit) {
        state.availableLimit = availableLimit;
    },
    SET_DUPLICATE_PERIOD(state, data) {
        state.duplicateTransactionPeriod = data.duplicateTransactionPeriod;
    },
};
const actions = {
    // name transaction enquiry
    async nameEnquiry({ }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.post(`/Transaction/nameEnquiry/${data}`, null, { headers });
            return response;
        }
    },
   // make transaction enquiry
    async transactionEnquiry({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.post(`/Transaction/transactionEnquiry`, encryptedData, { headers });
            return response;
        }
    },
    // confirm own account transaction
    async confirmTransaction({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            const resp = await this._vm.$http.get('https://api.ipify.org?format=json')
            const ip = resp.data.ip
            headers.REMOTE_ADDR = ip
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.post(`/Transaction/ownAccountTransfer`, encryptedData, { headers });
            return response;
        }
    },
    // interbank transfer enquiry
    async interbankNameEnquiry({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.post(`/Transaction/interBankNameEnquiry`, encryptedData, { headers });
            return response;
        }
    },
    // validate bank account
    async validateAcctNumber({ commit }, data) {
        // const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.get(`/Bank/get?accountNumber=${data}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            commit('SET_DESTINATION_ACCT_NUMBER', userParseData);
            return response;
        }
    },
    // confrim interbank transfer
    async confirmInterbankTransfer({ }, data) {
        const encryptedData = encrypt(data);
        const resp = await this._vm.$http.get('https://api.ipify.org?format=json')
        const ip = resp.data.ip
        headers.REMOTE_ADDR = ip
        let response = await this._vm.$http.post(`/Transaction/interBankTransfer`, encryptedData, { headers });
        return response;
    },
    // confirm local transfer
    async confirmLocalTransfer({ }, data) {
        const encryptedData = encrypt(data);
        const resp = await this._vm.$http.get('https://api.ipify.org?format=json')
        const ip = resp.data.ip
        headers.REMOTE_ADDR = ip
        let response = await this._vm.$http.post(`/Transaction/localTransfer`, encryptedData, { headers });
        return response;
    },
    // confirm bulk transfer
    async confirmBulkTransfer({ }, data) {
        const encryptedData = encrypt(data);
        const resp = await this._vm.$http.get('https://api.ipify.org?format=json')
        const ip = resp.data.ip
        headers.REMOTE_ADDR = ip
        let response = await this._vm.$http.post(`/Transaction/bulkTransfer`, encryptedData, { headers });
        return response;
    },
    // get beneficiary list
    async getBeneficiaryList({ commit }) {
        // check if access token exist
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.get(`/Beneficiary`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            commit('SET_BENEFICIARY_LIST', userParseData);
            return response;
        }
    },
    // confirm validate otp
    async confirmValidateOtp({ }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.post(`/Transaction/ValidateOtp`, encryptedData, { headers });
            return response;
        }
    },
    // generate otp for existing user
    async generateOtp({ }, data) {
        const encryptedData = encrypt(data);
        let response = await this._vm.$http.get(`/Transaction/GenerateOtp?accountNumber=${encryptedData}&platform=1`, { headers });
        return response;
    },
    // fund account with card
    async fundAccountWithCard({}, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.post(`/Account/initiateFundAccount`, encryptedData, { headers });
            return response;
        }
    },
    // get available transaction limit
    async getAvailableTransactionLimit({ commit }, data) {
        // const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.get(`/Transaction/GetAvailableTransactionLimit2?accountNumber=${data}&platform=1`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            commit('SET_AVAILABLE_LIMIT', userParseData);
            return response;
        }
    },
    // GET DUPLICATE TRANSACTION PERIOD
    async getDuplicateTransactionPeriod({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.get(`/SystemConfiguration`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            commit('SET_DUPLICATE_PERIOD', userParseData);
            return response;
        }
    },
};
const getters = {
   
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};